import { Box, BoxProps, Typography } from "@mui/material";

// The wordmark shown next to the TVEyes swirl (LogoEye). Rendered as text
// rather than the old "INSIGHT" letter-path SVG so the product name lives in
// one place. Brand blue on light, white on dark — matching the swirl.
export function LogoInsight({ dark, ...props }: Omit<BoxProps, "children"> & { dark?: boolean }) {
  return (
    <Box display="flex" alignItems="center" {...props}>
      <Typography
        component="span"
        sx={{
          fontWeight: 600,
          fontSize: 22,
          lineHeight: 1,
          letterSpacing: "0.04em",
          whiteSpace: "nowrap",
          userSelect: "none",
          color: dark ? "#FFFFFF" : "#286DB2",
        }}
      >
        ARCHIV3
      </Typography>
    </Box>
  );
}
